const PAGSEGURO_SDK_URL = 'https://assets.pagseguro.com.br/checkout-sdk-js/rc/dist/browser/pagseguro.min.js';

let sdkPromise = null;

export async function getPaymentConfig(apiBaseUrl) {
  const response = await fetch(`${apiBaseUrl}/payments/config`);
  if (!response.ok) {
    throw new Error('Não foi possível carregar a configuração de pagamento.');
  }
  return response.json();
}

export function onlyDigits(value) {
  return String(value || '').replace(/\D/g, '');
}

export function formatCardNumber(value) {
  return onlyDigits(value).slice(0, 19).replace(/(.{4})/g, '$1 ').trim();
}

export function formatExpiry(value) {
  const digits = onlyDigits(value).slice(0, 6);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}/${digits.slice(2)}`;
}

export async function loadPagSeguroSdk() {
  if (window.PagSeguro?.encryptCard) return window.PagSeguro;

  if (!sdkPromise) {
    sdkPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[src="${PAGSEGURO_SDK_URL}"]`);
      if (existing) {
        existing.addEventListener('load', () => resolve(window.PagSeguro));
        existing.addEventListener('error', reject);
        return;
      }

      const script = document.createElement('script');
      script.src = PAGSEGURO_SDK_URL;
      script.async = true;
      script.onload = () => resolve(window.PagSeguro);
      script.onerror = () => reject(new Error('Não foi possível carregar o SDK do PagBank.'));
      document.body.appendChild(script);
    });
  }

  const sdk = await sdkPromise;
  if (!sdk?.encryptCard) {
    throw new Error('SDK do PagBank indisponível para criptografar cartão.');
  }
  return sdk;
}

export async function encryptCardForPagSeguro(apiBaseUrl, cardForm) {
  const config = await getPaymentConfig(apiBaseUrl);
  if (!config.pagseguro_public_key) {
    throw new Error('Não foi possível obter a chave pública do PagBank. Verifique PAGSEGURO_TOKEN no backend.');
  }

  const [expMonth, expYearInput] = String(cardForm.expiry || '').split('/');
  const expYear = expYearInput?.length === 2 ? `20${expYearInput}` : expYearInput;
  const sdk = await loadPagSeguroSdk();
  const result = sdk.encryptCard({
    publicKey: config.pagseguro_public_key,
    holder: cardForm.holder_name,
    number: onlyDigits(cardForm.number),
    expMonth,
    expYear,
    securityCode: onlyDigits(cardForm.security_code),
  });

  if (result?.hasErrors) {
    throw new Error('Dados do cartão inválidos. Verifique número, validade e CVV.');
  }

  const encryptedCard = result?.encryptedCard || result?.encrypted_card;
  if (!encryptedCard) {
    throw new Error('Não foi possível criptografar o cartão.');
  }

  return {
    encrypted_card: encryptedCard,
    holder_name: cardForm.holder_name,
    installments: Number(cardForm.installments || 1),
  };
}
